import { nlpIntegration } from '@mi-front/api-clients';
import { toTimestamp } from '@mi-front/core';

import { NEW_TOPIC_MAX_AGE_MS } from './consts';

/**
 * Normalizes an ISO datetime for live-topics API query params.
 * Topic timestamps may include microsecond precision (6 fractional digits); the API expects milliseconds (3).
 */
export function formatLiveTopicsQueryDatetime(datetime: string | Date): string {
  return new Date(datetime).toISOString();
}

/**
 * Returns true if the topic's start_time is within the last 15 minutes.
 * Used to hide the "NEW" chip for older topics.
 */
export function isTopicWithinLast15Min(topic: nlpIntegration.TopicOutDto): boolean {
  if (!topic.start_time) return false;
  const startTs = toTimestamp(topic.start_time);
  return Date.now() - startTs <= NEW_TOPIC_MAX_AGE_MS;
}

/**
 * Returns true when the playhead is within the topic's time range [start_time, end_time).
 */
export function isTopicActiveAt(
  topic: nlpIntegration.TopicOutDto,
  currentTs: number | null,
): boolean {
  if (currentTs == null || !topic.start_time || !topic.end_time) return false;
  const startTs = toTimestamp(topic.start_time);
  const endTs = toTimestamp(topic.end_time);
  return currentTs >= startTs && currentTs < endTs;
}
